import { CountryCode, CountryNames, OrganizationCountry } from "../enums/country";
import { getRegionOptions } from "../region";
const COUNTRY_NAME_TO_CODE = {
    [CountryNames.Canada]: CountryCode.CA,
    [CountryNames.UnitedStates]: CountryCode.US,
    [CountryNames.Australia]: CountryCode.AU,
};
const buildRegionOptions = (countryName) => {
    return getRegionOptions(COUNTRY_NAME_TO_CODE[countryName]).map((option) => ({
        label: option.label,
        value: option.code,
        countryName,
    }));
};
export const getOrderedRegionOptions = (organizationCountry) => {
    const canadaOptions = buildRegionOptions(CountryNames.Canada);
    const unitedStatesOptions = buildRegionOptions(CountryNames.UnitedStates);
    const australiaOptions = buildRegionOptions(CountryNames.Australia);
    if (organizationCountry === OrganizationCountry.Canada) {
        return [...canadaOptions, ...unitedStatesOptions, ...australiaOptions];
    }
    if (organizationCountry === OrganizationCountry.Australia) {
        return [...australiaOptions, ...unitedStatesOptions, ...canadaOptions];
    }
    return [...unitedStatesOptions, ...canadaOptions, ...australiaOptions];
};
